import React from 'react';
import { Image } from 'react-bootstrap';
import { connect } from 'react-redux';

import Icon from '@svgr-iconkit/foundation';

import trashCanIcon from 'assets/images/trash_can.svg';

const TableCell = ({ data }) => {
  const tipClass = React.useMemo(() => {
    switch (data?.diffState) {
      case '+':
        return 'cell-tip plus';
      case '-':
        return 'cell-tip minus';
      default:
        return 'cell-tip';
    }
  }, [data?.diffState]);

  if (data?.title) {
    return <td className="cell-title">{data?.title}</td>;
  }
  return (
    <td>
      <div className="d-flex flex-column justify-content-end align-items-end">
        <span className="cell-value">{data?.value}</span>
        {data?.tip ? (
          <span className={tipClass}>
            {data?.diffState === '+' ? <Icon name="arrow-up" /> : null}
            {data?.diffState === '-' ? <Icon name="arrow-down" /> : null}
            {data?.tip}
          </span>
        ) : null}
      </div>
    </td>
  );
};

const mapPropsToState = (state) => ({
  selectedStoreIds: state.metricTable.selectedStoreIds,
});

const MetricTableBody = ({
  selectedStoreIds,
  tableIndex,
  tableName,
  tableData,
  onDeleteStore = () => {},
}) => {
  const storeCountTitle = React.useMemo(() => {
    if (selectedStoreIds?.length > 0) {
      return `(${selectedStoreIds?.length} Store(s))`;
    }
    return '(All Store(s))';
  }, [selectedStoreIds]);

  return (
    <tbody>
      {tableData?.map((rowData, index) => {
        if (index === 0) {
          return (
            <tr key={index}>
              <td className="white-background" rowSpan={tableData?.length ?? 1}>
                {tableIndex > 0 ? (
                  <div className="d-flex flex-row justify-content-between align-items-start flex-gap-8">
                    <span className="table-row-title">{tableName}</span>
                    <Image
                      src={trashCanIcon}
                      className="not-drag edit-btn"
                      onClick={() => onDeleteStore()}
                    />
                  </div>
                ) : (
                  <>
                    <span className="table-row-title">Total</span>
                    <br />
                    <span className="table-row-title">{storeCountTitle}</span>
                  </>
                )}
              </td>
              {rowData?.map((cell, rowIndex) => {
                return <TableCell key={`${index}-${rowIndex}`} data={cell} />;
              })}
              <td></td>
            </tr>
          );
        }
        return (
          <tr key={index}>
            {rowData?.map((cell, rowIndex) => {
              return <TableCell key={`${index}-${rowIndex}`} data={cell} />;
            })}
            <td></td>
          </tr>
        );
      })}
    </tbody>
  );
};

export default connect(mapPropsToState)(MetricTableBody);
